/*
 * @Descripttion: 
 * @version: 
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-21 18:20:16
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-09-10 11:07:09
 */
import { aseDecode } from '@/js/utils'
export default {
    appName(state) { //appName
        return state.baseInfo.appName
    },
    companyName(state) { //companyName
        return state.baseInfo.companyName
    },
    organizationName(state) { //机构名称organizationName
        return state.baseInfo.organizationName
    },
    organizationNickName(state) { //机构名称organizationName
        return state.baseInfo.organizationNickName
    },
    isLogin(state) { //登录状态
        return state.isLogin;
    },
    userID(state) { //角色ID
        // return aseDecode(state.userID, "Wechat-8847￥￥%ERF_)((^%4dkfj&45");
        return state.userID;
    },
    fullPath(state) {
        return state.fullPath;
    },
}


// WEBPACK FOOTER //
// ./src/store/getters.js